var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"applicants"},[_c('Breadcrumbs',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_c('ApplicantTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }